import "regenerator-runtime/runtime";
import classNames from "classnames";
import { ReactNode } from "react";
import { useHotkeys } from "react-hotkeys-hook";

import { useDictationEffect } from "shared/hooks/useDictation";

import { DialogEnum } from "./Dialog";

type DialogButtonProps = {
  currentDialog: DialogEnum | null;
  wantedDialog: DialogEnum;
  setDialog: Function;
  children: ReactNode;
  hotkey?: string;
  useKey?: boolean;
  className?: string;
  title: string;
  dictationKeys?: string[];
  hasDictation?: boolean;
};

const DialogButton = ({
  currentDialog,
  wantedDialog,
  setDialog,
  children,
  hotkey,
  useKey,
  className,
  title,
  dictationKeys,
}: DialogButtonProps) => {
  useDictationEffect([title, ...(dictationKeys ?? [])], () => {
    setDialog(wantedDialog);
  });

  const toggleDialog = () => {
    if (currentDialog === wantedDialog) {
      setDialog(null);
    } else {
      setDialog(wantedDialog);
    }
  };

  if (hotkey)
    useHotkeys(
      hotkey,
      (e) => {
        if (
          (e.code === "KeyD" && wantedDialog === DialogEnum.InputDiagnosis) ||
          (e.code === "KeyO" && wantedDialog === DialogEnum.StainOrdering)
        )
          e.preventDefault();
        toggleDialog();
      },
      { scopes: ["viewerHotkeys"], ...(useKey && { ignoreModifiers: true }) },
      [currentDialog, wantedDialog, setDialog]
    );

  useHotkeys(
    "Escape",
    () => {
      setDialog(null);
    },
    [setDialog]
  );

  return (
    <button
      onClick={toggleDialog}
      className={classNames(className, {
        active: currentDialog === wantedDialog,
      })}
      title={title}
    >
      {children}
    </button>
  );
};

export default DialogButton;
